import { Alert, Button } from "@mui/material";
import { GovAction } from "./useGovAction";

/**
 * Inline error under an action form. On a 409 (someone else changed the
 * item first) it offers "Reload", which clears the error and re-fetches.
 */
const ActionError = ({ action, onReload }: { action: GovAction; onReload: () => void }) => {
  if (!action.error) return null;
  return (
    <Alert
      severity="error"
      sx={{ mt: 1.5 }}
      action={
        action.conflict ? (
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              action.clear();
              onReload();
            }}
          >
            Reload
          </Button>
        ) : undefined
      }
    >
      {action.error}
    </Alert>
  );
};

export default ActionError;
